/**
 * This will scroll down when user selects language
 * @example ng-strip-chat
 */

const ngStripChat = ['$http', ($http) => {
    return {
        link: function ($scope, $element, $params) {
            $scope.stripChat = {
                models: [],
            };
            $http.get('/service/dating.json?genre=' + $scope.service.genre ).then((response) => {
                if ( typeof response.data.payload.models !== "undefined") {
                    $scope.stripChat.models = response.data.payload.models;
                }
            });
        }
    }
}];

export default ngStripChat;

